import MasterLayout from "../masterLayout/MasterLayout";

import Subscription from "../components/Subscription";

export default function ManageSubscription() {
  return (
    <div>
      <MasterLayout>
        <Subscription />
      </MasterLayout>
    </div>
  );
}
